export const environment = {
  production: false,
  debugApi: true,
  apiUrl: 'https://vaggit-backend-dev.onrender.com',
  // apiUrl: 'http://localhost:3000',
  publicUrl: 'https://www.vaggit.com',
};
